import gql from 'graphql-tag';
import axios from 'axios';

const UploadPdfMutation = gql`
  mutation uploadEvidencePdf {
    data: uploadEvidencePdf {
      success
      image {
        url
        uploadUrl
      }
    }
  }
`;

export const uploadPdf = async (client, params, isEvent = false) => {
  const url = await client.mutate({
    mutation: UploadPdfMutation,
  });

  const uploadUrl = url?.data.data.image.uploadUrl;

  // The accessUrl and fileName should be sent to the backend
  const accessUrl = url?.data.data.image.url;
  const file = params.data.pdf.rawFile;
  const fileName =params.data.pdf.rawFile.name

  const response = await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });

  return {accessUrl, fileName};
};
